<template lang="pug">
  el-row
    .main.label-divider(:class="addMarginTop ? 'padding-top' : ''")
      span.title {{label}}
        span(v-if="required").required *
        span &nbsp
        span(slot="label")
          el-tooltip(
            v-if="tooltip"
            effect='light',
            placement='bottom'
          )
            span(slot="content")
              p(v-html="tooltip")
            i.el-icon-info
      .btn-action
        slot(name="actionButton")
    .divider
    slot(name="body")
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: null
    },
    addMarginTop: {
      Type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";
@import "@/assets/styles/_variables.scss";

.main {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.required {
  color: $error;
}

.label-divider {
  font-weight: bold;
}

.padding-top {
  padding-top: 30px;
}

.divider {
  border: 1px solid $--divider-color;
}

.btn-action {
  display: flex;
  justify-self: flex-end;
}

.title {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AppDivider.vue